<template>
    <div>
        <div class="row no-gutters">
            <div class="col-xl-6 col-lg-12">
                <div class="row pl-3 pr-2 mt-2 item" v-for="group in firstColumn" :key="group.id">
                    <div class="col-12">
                        <GroupCard :group="group"></GroupCard>
                    </div>
                </div>


                <div class="col-12" v-if="editModeEnabled">
                    <button class="btn btn-sm mt-2" @click="newGroup.column = 0; $refs.addGroupModel.open()">
                        <i class="fa fa-plus"></i> {{ $t('UI_INSTANCE_MEMBER_GROUP_ADD') }}
                    </button>
                </div>
            </div>
            <div class="col-xl-6 col-lg-12">

                <div class="row pl-3 pr-2 mt-2 item" v-for="group in secondColumn" :key="group.id">
                    <div class="col-12">
                        <GroupCard :group="group"></GroupCard>
                    </div>
                </div>


                <div class="col-12" v-if="editModeEnabled">
                    <button class="btn btn-sm mt-2" @click="newGroup.column = 1; $refs.addGroupModel.open()">
                        <i class="fa fa-plus"></i> {{ $t('UI_INSTANCE_MEMBER_GROUP_ADD') }}
                    </button>
                </div>
            </div>
        </div>

        <InsertEmptyChapter/>

        <!-- Create Member Group-->
        <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_ADD')" ref="addGroupModel">
            <div class="form-group">
                <label for="title">{{ $t("UI_INSTANCE_MEMBER_GROUP_TITLE") }}</label>
                <input type="text" id="title" v-model="newGroup.title" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_TITLE')" class="form-control" v-on:keyup.enter="addGroup">
            </div>

            <div class="form-group">
                <label for="columnGroup">{{ $t('UI_INSTANCE_MEMBER_GROUP_COLUMN') }}</label><br>
                <div class="btn-group" id="columnGroup">
                    <button class="btn btn-outline-dark" :class="{'btn-dark text-white': newGroup.column === 0}" @click="newGroup.column = 0">
                        {{ $t('UI_INSTANCE_MEMBER_GROUP_COLUMN_LEFT') }}
                    </button>
                    <button class="btn btn-outline-dark" :class="{'btn-dark text-white': newGroup.column === 1}" @click="newGroup.column = 1">
                        {{ $t('UI_INSTANCE_MEMBER_GROUP_COLUMN_RIGHT') }}
                    </button>
                </div>
            </div>

            <div class="form-group">
                <label for="color">{{ $t('UI_INSTANCE_MEMBER_GROUP_COLOR') }}</label>
                <swatches v-model="newGroup.color" id="color" inline></swatches>
            </div>


            <div slot="button">
                <button class="btn btn-primary" @click="addGroup">
                    {{ $t("UI_MODAL_BUTTON_CREATE") }}
                </button>
                <button class="btn btn-secondary ml-1" @click="$refs.addGroupModel.close()">
                    {{ $t("UI_MODAL_BUTTON_CLOSE") }}
                </button>
            </div>
        </sweet-modal>

    </div>
</template>

<script>
import Swatches from 'vue-swatches';
import { SweetModal } from 'sweet-modal-vue';
import GroupCard from './GroupCard';
import InsertEmptyChapter from '../../../Chapters/Utils/InsertEmptyChapter';

import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

const InstanceGroupRepository = RepositoryFactory.get('instanceGroups');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'MemberList',
  components: {
    InsertEmptyChapter, GroupCard, SweetModal, Swatches,
  },
  props: [],
  mounted() {
    	/*
    	  READ ONLY MODE: Set default Tabs
    	 */
    if (this.$store.getters.instanceInReadOnly) {
      	if (this.$store.getters.instanceInLiveMode) {
		      this.$store.commit('setActiveSidePanelTab', { position: 'top', tab: 'livestream' });
		      this.$store.commit('setActiveSidePanelTab', { position: 'bottom', tab: 'devicecontrol' });
      } else {
		      this.$store.commit('setActiveSidePanelTab', { position: 'top', tab: 'video' });
		      this.$store.commit('setActiveSidePanelTab', { position: 'bottom', tab: '' });
      }
    }
  },
  methods: {
    /**
       * Adds a group to the Instance
       * @returns {Promise<boolean>}
       */
    async addGroup() {
      if (this.newGroup.title.length < 1) {
        this.$snotify.error(this.$t('UI_INSTANCE_MEMBER_GROUP_TITLE_REQUIRED'));
        return false;
      }

      await InstanceGroupRepository.add(this.newGroup.title, this.newGroup.column, this.newGroup.color).then(() => {
        this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_ADDED', { name: this.newGroup.title }));
        this.newGroup = { title: '', column: 0, color: null };
        InstanceRepository.refetchActive(false);
        this.$refs.addGroupModel.close();
      });
    },
  },
  data() {
    return {
      newGroup: {
        title: '',
        column: 0,
        color: null,
      },
	    moving: {
		    sourceGroup: null,
		    targetGroup: null,
		    targetPosition: null,
	    },
    };
  },
  computed: {
    instance() {
      return this.$store.getters.activeInstanceData;
    },
    groups() {
      return this.instance.members;
    },
    firstColumn() {
      return this.groups.filter(group => group.column === 0);
    },
    secondColumn() {
      return this.groups.filter(group => group.column === 1);
    },
    editModeEnabled() {
      return this.$store.getters.instanceGroupEditEnabled;
    },
  },
};
</script>
